import SliderArrow from "components/base/Arrow";
import BackButton from "components/base/BackButton";
import Button from "components/base/Button";
import Calendar from "components/base/Calendar";
import Card from "components/base/Card";
import CustomTooltip from "components/base/CustomTooltip";
import DateRangeSlider from "components/base/DateRangeSlider";
import DraggableList from "components/base/DraggableList";
import Errors from "components/base/Errors";
import File from "components/base/File";
import { Input, Switcher, Text } from "components/base/Form";
import Header from "components/base/Header";
import Icon from "components/base/Icon";
import Image from "components/base/Image";
import InputSelect from "components/base/InputSelect";
import Page from "components/base/Page";
import ProgressRing from "components/base/ProgressRing";
import QiniuUploader from "components/base/QiniuUploader";
import SearchBar from "components/base/SearchBar";
import Spinner from "components/base/Spinner";
import Status from "components/base/Status";
import { Alert } from "components/base/Toast";
import { useState } from "react";

const ComponentsShowcase = () => {
  const [activeTab, setActiveTab] = useState("按钮");

  const components = {
    按钮: {
      components: [
        {
          name: "Button (primary)",
          component: <Button primary>主要按钮</Button>,
          code: "<Button primary>主要按钮</Button>",
        },
        {
          name: "Button (danger)",
          component: <Button danger>危险按钮</Button>,
          code: "<Button danger>危险按钮</Button>",
        },
        {
          name: "Button (odoo)",
          component: <Button odoo>Odoo按钮</Button>,
          code: "<Button odoo>Odoo按钮</Button>",
        },
        {
          name: "Button (loading)",
          component: <Button loading>加载中按钮</Button>,
          code: "<Button loading>加载中按钮</Button>",
        },
        {
          name: "BackButton",
          component: <BackButton />,
          code: "<BackButton />",
        },
        {
          name: "SliderArrow",
          component: (
            <div className="relative h-20 w-full">
              <SliderArrow right onClick={() => {}} className="" />
              <SliderArrow left onClick={() => {}} className="" />
            </div>
          ),
          code: "<SliderArrow right onClick={() => {}} />\n<SliderArrow left onClick={() => {}} />",
        },
      ],
    },
    卡片: {
      components: [
        {
          name: "Card",
          component: (
            <Card title="卡片标题" subtitle="卡片副标题">
              卡片内容
            </Card>
          ),
          code: '<Card title="卡片标题" subtitle="卡片副标题">卡片内容</Card>',
        },
        {
          name: "Card (clickable)",
          component: (
            <Card title="可点击卡片" onClick={() => alert("卡片被点击")}>
              可点击卡片内容
            </Card>
          ),
          code: '<Card title="可点击卡片" onClick={() => alert("卡片被点击")}>可点击卡片内容</Card>',
        },
      ],
    },
    表单元素: {
      components: [
        {
          name: "InputSelect",
          component: (
            <InputSelect
              options={[
                { label: "选项1", value: "1" },
                { label: "选项2", value: "2" },
              ]}
            />
          ),
          code: '<InputSelect options={[{label: "选项1", value: "1"}, {label: "选项2", value: "2"}]} />',
        },
        { name: "Calendar", component: <Calendar />, code: "<Calendar />" },
        {
          name: "DateRangeSlider",
          component: <DateRangeSlider />,
          code: "<DateRangeSlider />",
        },
        {
          name: "SearchBar",
          component: <SearchBar placeholder="搜索..." />,
          code: '<SearchBar placeholder="搜索..." />',
        },
        {
          name: "Input",
          component: <Input placeholder="请输入内容..." />,
          code: '<Input placeholder="请输入内容..." />',
        },
        {
          name: "Text",
          component: <Text placeholder="请输入多行内容..." />,
          code: '<Text placeholder="请输入多行内容..." />',
        },
        {
          name: "Switcher",
          component: <Switcher checked={true} onChange={() => {}} />,
          code: "<Switcher checked={true} onChange={() => {}} />",
        },
        {
          name: "File",
          component: (
            <File name="example.pdf" link="https://example.com/file.pdf" />
          ),
          code: '<File name="example.pdf" link="https://example.com/file.pdf" />',
        },
      ],
    },
    图标和状态: {
      components: [
        {
          name: "Icon",
          component: <Icon icon="search" />,
          code: '<Icon icon="search" />',
        },
        {
          name: "Status",
          component: <Status value="active" />,
          code: '<Status value="active" />',
        },
        {
          name: "ProgressRing",
          component: <ProgressRing progress={75} />,
          code: "<ProgressRing progress={75} />",
        },
        { name: "Spinner", component: <Spinner />, code: "<Spinner />" },
      ],
    },
    其他: {
      components: [
        {
          name: "CustomTooltip",
          component: (
            <CustomTooltip content="提示内容">
              <span>悬停查看提示</span>
            </CustomTooltip>
          ),
          code: '<CustomTooltip content="提示内容"><span>悬停查看提示</span></CustomTooltip>',
        },
        {
          name: "Toast",
          component: (
            <Button onClick={() => Alert("success", "这是一个Toast消息")}>
              点击显示Toast消息
            </Button>
          ),
          code: "// Toast 是一个函数，不是组件\nAlert('success', '这是一个Toast消息');\n\n// 通常与按钮一起使用\n<Button onClick={() => Alert('success', '这是一个Toast消息')}>显示Toast</Button>",
        },
        {
          name: "Image",
          component: <Image src="/waboba-logo-color.png" width={100} />,
          code: '<Image src="/waboba-logo-color.png" width={100} />',
        },
        {
          name: "Header",
          component: <Header title="页面标题" />,
          code: '<Header title="页面标题" />',
        },
        {
          name: "Errors",
          component: <Errors error="这是一个错误消息" />,
          code: '<Errors error="这是一个错误消息" />',
        },
        {
          name: "DraggableList",
          component: (
            <DraggableList componentList={["项目1", "项目2", "项目3"]} />
          ),
          code: "<DraggableList\n  componentList={['项目1', '项目2', '项目3']}\n/>",
        },
        {
          name: "QiniuUploader",
          component: (
            <QiniuUploader
              file={new File([""], "example.jpg", { type: "image/jpeg" })}
              filename="example.jpg"
              // onUploaded={(url) => Alert("success", `图片上传成功: ${url}`)}
              preview={true}
            />
          ),
          code: `// 基本用法 - 上传图片文件
<QiniuUploader
  file={imageFile}
  filename="example.jpg"
  onUploaded={(url) => console.log("图片上传成功:", url)}
/>

// 带预览功能
<QiniuUploader
  preview={true}
  file={imageFile}
  filename="example.jpg"
  onUploaded={(url) => console.log("图片上传成功:", url)}
/>`,
        },
      ],
    },
  };

  return (
    <Page
      backTo="./.."
      title="基础组件展示"
      childrenClassName="p-6"
      leftButtons={
        <Button onClick={() => Alert("success", "这是一个信息提示")}>
          左侧按钮
        </Button>
      }
      rightButtons={
        <Button onClick={() => Alert("success", "这是一个信息提示")}>
          右侧按钮
        </Button>
      }
    >
      <div className="flex flex-col md:flex-row md:space-x-6">
        {/* 左侧导航栏 */}
        <div className="w-full md:w-1/4 lg:w-1/6 flex-shrink-0 mb-6 md:mb-0">
          <div className="sticky top-4">
            <div className="flex flex-col space-y-2">
              {Object.keys(components).map((tab) => (
                <Button
                  key={tab}
                  className={`text-left justify-start ${activeTab === tab ? "bg-sky-100 text-sky-700" : ""}`}
                  onClick={() => {
                    setActiveTab(tab);
                    // 滚动到对应区域
                    document
                      .getElementById(tab)
                      ?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  {tab}
                </Button>
              ))}
            </div>
          </div>
        </div>

        {/* 右侧内容区域 */}
        <div className="w-full md:w-3/4 lg:w-4/5">
          {Object.keys(components).map((categoryName) => (
            <div key={categoryName} id={categoryName} className="mb-8">
              <h2 className="text-xl font-bold mb-4 pb-2 border-b">
                {categoryName}
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {components[categoryName].components.map((item, index) => (
                  <Card key={index} title={item.name} className="flex flex-col">
                    <div className="mb-4 p-4 border border-dashed rounded-lg flex items-center justify-center min-h-[100px]">
                      {item.component}
                    </div>
                    <div className="mt-auto">
                      <div className="text-sm font-medium mb-2">使用示例:</div>
                      <pre className="bg-gray-100 dark:bg-gray-900 p-2 rounded-lg text-xs overflow-x-auto">
                        {item.code}
                      </pre>
                    </div>
                  </Card>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Page>
  );
};

export default ComponentsShowcase;
